import { ReactComponent as LogoSrc } from "../assets/logos/logo-src.svg";
import { ReactComponent as LogoWhite } from "../assets/logos/logo-white.svg";

const logos = {
  LogoSrc,
  LogoWhite
};

export default logos;
